import React from "react";

export default function MdOutlineWest(props) {
  const { size = 16 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="m9 19l-7-7l7-7l1.4 1.4L5.825 11H22v2H5.825l4.6 4.6z"
      ></path>
    </svg>
  );
}
